import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    backgroundColor: '',
    headerBackgroundColor: '',
    enableMobileMenuSmall: '',
    enableBackgroundImage: false,
    enableClosedSidebar: false,
    enableFixedHeader: true,
    enableHeaderShadow: true,
    enableSidebarShadow: true,
    enableFixedFooter: true,
    enableFixedSidebar: true,
    colorScheme: 'white',
    backgroundImageOpacity: 'opacity-06',
    enablePageTitleIcon: true,
    enablePageTitleSubheading: true,
    enablePageTabsAlt: true,
    enableMobileMenu: false,
};

const themeSlice = createSlice({
    name: 'ThemeOptions',
    initialState,
    reducers: {
        setEnableBackgroundImage: (state, action) => { state.enableBackgroundImage = action.payload; },
        setEnableFixedHeader: (state, action) => { state.enableFixedHeader = action.payload; },
        setEnableHeaderShadow: (state, action) => { state.enableHeaderShadow = action.payload; },
        setEnableSidebarShadow: (state, action) => { state.enableSidebarShadow = action.payload; },
        setEnablePageTitleIcon: (state, action) => { state.enablePageTitleIcon = action.payload; },
        setEnablePageTitleSubheading: (state, action) => { state.enablePageTitleSubheading = action.payload; },
        setEnablePageTabsAlt: (state, action) => { state.enablePageTabsAlt = action.payload; },
        setEnableFixedSidebar: (state, action) => { state.enableFixedSidebar = action.payload; },
        setEnableMobileMenu: (state, action) => { 
            console.log("Setting enableMobileMenu to", action.payload);
            state.enableMobileMenu = action.payload; },
        setEnableMobileMenuSmall: (state, action) => { state.enableMobileMenuSmall = action.payload; },
        setEnableClosedSidebar: (state, action) => { state.enableClosedSidebar = action.payload; },
        setEnableFixedFooter: (state, action) => { state.enableFixedFooter = action.payload; },
        setBackgroundColor: (state, action) => { state.backgroundColor = action.payload; },
        setHeaderBackgroundColor: (state, action) => { state.headerBackgroundColor = action.payload; },
        setColorScheme: (state, action) => { state.colorScheme = action.payload; },
        setBackgroundImage: (state, action) => { state.backgroundImage = action.payload; },
        setBackgroundImageOpacity: (state, action) => { state.backgroundImageOpacity = action.payload; },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            (action) => action.type.startsWith('THEME_OPTIONS/'),
            (state, action) => {
                const key = action.type.replace('THEME_OPTIONS/SET_', '').toLowerCase()
                    .replace(/_([a-z])/g, (g) => g[1].toUpperCase());
                
                // Special cases for naming mismatches
                const finalKey = key === 'enableMobileMenuSmall' ? 'enableMobileMenuSmall' : key;
                
                // Convert THEME_OPTIONS/SET_ENABLE_MOBILE_MENU to enableMobileMenu
                const valueName = action.type.replace('THEME_OPTIONS/SET_', '')
                    .toLowerCase()
                    .replace(/_([a-z])/g, (g) => g[1].toUpperCase());
                
                if (action[valueName] !== undefined) {
                    state[valueName] = action[valueName];
                }
            }
        );
    }
});

export const {
    setEnableBackgroundImage,
    setEnableFixedHeader,
    setEnableHeaderShadow,
    setEnableSidebarShadow,
    setEnablePageTitleIcon,
    setEnablePageTitleSubheading,
    setEnablePageTabsAlt,
    setEnableFixedSidebar,
    setEnableMobileMenu,
    setEnableMobileMenuSmall,
    setEnableClosedSidebar,
    setEnableFixedFooter,
    setBackgroundColor,
    setHeaderBackgroundColor,
    setColorScheme,
    setBackgroundImage,
    setBackgroundImageOpacity,
} = themeSlice.actions;

export default themeSlice.reducer;
